import type { NormalizedNotStartedCourse } from 'bundles/degree-home/components/v2/types/courseStates';

// Filters 'notStarted' courses to find items where is no active session, and there are no enrollable sessions.
export const upcomingCoursesFilterFn = (course: NormalizedNotStartedCourse) => {
  return !course.activeSessionId && !course.hasEnrollableSession;
};

// Filters 'notStarted' courses to find items where there is no active session, and there are sessions available to enroll in
export const enrollableCoursesFilterFn = (course: NormalizedNotStartedCourse) => {
  return !course.activeSessionId && course.hasEnrollableSession;
};
